import { render, staticRenderFns } from "./PoyntPrivateKey.vue?vue&type=template&id=1d4288dc&"
import script from "./PoyntPrivateKey.vue?vue&type=script&lang=ts&"
export * from "./PoyntPrivateKey.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports